import axios from 'axios';

import { publicAxiosHeaderV2, getV2RootUrl } from 'common/helpers/apiHelper';

export const listReservationAvailabilities = (queryString) =>
  axios.get(
    `${getV2RootUrl()}/reservation-availability/for-web?${queryString}`,
    publicAxiosHeaderV2()
  );
